import "./index.css";

import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import { ApolloProvider } from "@apollo/client";
import { MsalProvider } from "@azure/msal-react";

import App from "./App";
import { msalInstance } from "./msalConfig";
import { apolloClient } from "./apolloClient";
import initClarity from "./utils/initClarity";

if (process.env.NODE_ENV === "production") {
  initClarity();
}

ReactDOM.render(
  <MsalProvider instance={msalInstance}>
    <ApolloProvider client={apolloClient}>
      <Router>
        <App />
      </Router>
    </ApolloProvider>
  </MsalProvider>,
  document.getElementById("root")
);
